module.exports = __webpack_public_path__ + "img/aura.4ed0e375.png";